/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type BoardEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const boardEntryPoint: EntryPoint<BoardEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForUserVisible<BoardEntryPointComponent>(
		/* webpackChunkName: "async-servicedesk-board", jiraSpaEntry: "async-servicedesk-board" */ './ServicedeskBoard.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
